<template lang="pug">
header.container-fliud
  .header_bg.text-center(
    :style="{ backgroundImage: 'url(' + aboutUsCommon.Banner + ')' }"
  )
</template>

<script>
import MediaImg from "@/components/common/MediaImg";

export default {
  name: "Header",
  components: {
    "media-img": MediaImg,
  },
  props: {
    aboutUsCommon: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/header";
</style>
